import { render, staticRenderFns } from "./base-radio-checkbox.vue?vue&type=template&id=91b91414&"
import script from "./base-radio-checkbox.vue?vue&type=script&lang=js&"
export * from "./base-radio-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./base-radio-checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports